class Period {
    constructor({ value, name}) {
        this.value = value; // public property
        this.name = name; // public property
    }
}

export default Period;
